

import { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

export const useBookings = () => {
    const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
    const [scheduleDate, setScheduleDate] = useState("");
    const [scheduleTime, setScheduleTime] = useState("");
    const [guestName, setGuestName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [numberOfGuests, setNumberOfGuests] = useState(2);
    const [durationMinutes, setDurationMinutes] = useState(2);
    const [bookingLoading, setBookingLoading] = useState(false);
    const [bookingSuccess, setBookingSuccess] = useState(false);
    const [bookingDetails, setBookingDetails] = useState(null);
    const [waitingListMessage, setWaitingListMessage] = useState(null);

    const getAuthVars = () => {
        const customerId = localStorage.getItem("customerId");
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");
        return { customerId, token, vendorId };
    };

    const openScheduleModal = () => {
        setScheduleDate("");
        setScheduleTime("");
        setGuestName("");
        setPhoneNumber("");
        setNumberOfGuests(2);
        setDurationMinutes(2);
        setBookingSuccess(false);
        setWaitingListMessage(null);
        setIsScheduleModalOpen(true);
    };

const handleScheduleConfirm = async () => {
    if (bookingLoading) return;

    if (
        !scheduleDate ||
        !scheduleTime ||
        !guestName?.trim() ||
        !phoneNumber?.trim() ||
        phoneNumber.length < 10 ||
        numberOfGuests < 1
    ) {
        toast.error("Please fill all required fields correctly");
        return;
    }

    const { customerId, token } = getAuthVars();

    if (!customerId || !token) {
        toast.error("Please login first");
        return;
    }

    setBookingLoading(true);

    try {

        // ✅ API required payload
        const payload = {

    startTime: `${scheduleTime}:00`,

    durationMinutes: Number(durationMinutes),

    phoneNumber: phoneNumber.trim(),

    guestName: guestName.trim(),

    bookingDate: scheduleDate,

    capacity: Number(numberOfGuests),

    tableId: 110,

    paymentEnable: false
};

        console.log("📦 BOOKING PAYLOAD:", payload);

        const response = await axios.post(
            `https://backend.maamaas.com/food/api/seatingdetails/shedule/advance/booking/1?customerId=${customerId}`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        console.log("✅ Booking Response:", response.data);

        const responseData = response.data;

        const isWaiting =
            (typeof responseData === "string" &&
                responseData.toLowerCase().includes("waiting")) ||
            (responseData?.message &&
                responseData.message.toLowerCase().includes("waiting")) ||
            responseData?.waitingList === true;

        // ✅ WAITING LIST
        if (isWaiting) {

            setWaitingListMessage(
                responseData?.message ||
                "Table booked but added to waiting list"
            );

            setBookingSuccess(false);

            return;
        }

        // ✅ SUCCESS
        setBookingSuccess(true);

        setWaitingListMessage(null);

        setBookingDetails({
            bookingId: responseData?.id || responseData?.bookingId,
            guestName,
            phoneNumber,
            numberOfGuests,
            date: scheduleDate,
            time: scheduleTime,
            durationMinutes
        });

        toast.success(`Table booked for ${guestName} 🎉`);

    } catch (error) {

        console.error("❌ Booking Error:", error);

        const errorData = error.response?.data;

        const isWaiting =
            (typeof errorData === "string" &&
                errorData.toLowerCase().includes("waiting")) ||
            (errorData?.message &&
                errorData.message.toLowerCase().includes("waiting")) ||
            errorData?.waitingList === true;

        if (isWaiting) {

            setWaitingListMessage(
                errorData?.message ||
                "Added to waiting list"
            );

            setBookingSuccess(false);

            return;
        }

        toast.error(
            errorData?.message ||
            error.message ||
            "Booking failed"
        );

    } finally {

        setBookingLoading(false);
    }
};

    return {
        isScheduleModalOpen,
        setIsScheduleModalOpen,
        scheduleDate,
        setScheduleDate,
        scheduleTime,
        setScheduleTime,
        guestName,
        setGuestName,
        phoneNumber,
        setPhoneNumber,
        numberOfGuests,
        setNumberOfGuests,
        durationMinutes,
        setDurationMinutes,
        bookingLoading,
        bookingSuccess,
        bookingDetails,
        waitingListMessage,
        openScheduleModal,
        handleScheduleConfirm
    };
};